export const fileTypeDownloadOptions: string[] = ['Secureds', 'Debtors', 'Filings', 'Events'];
